import { Button, Input, Select, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingOutlined } from '@ant-design/icons';
import { faChevronLeft, faClose, faSearch, faX } from '@fortawesome/free-solid-svg-icons';
import GeneralHelper from '../../helpers/general';
import useIsMobile from '../../helpers/customHooks/useIsMobile';


const LocationSearch = ({ loading, value, className, rounded, onClick, onClear, style, logo, hasResults, nullish, options, onSelect, handleSelectOnChange }) => {
	const query = GeneralHelper.getParamsFromUrl();
	const [searchValue, setSearchValue] = useState(value || query?.search);

	const searchRef = useRef(null);
	const history = useHistory();
	const isMobile = useIsMobile();
	const [locationsOptions, setLocationsOptions] = useState(null);

	const hadleFilterSelect = (optionA, optionB) => {
		return (optionB?.search_key ?? '').toLowerCase().localeCompare((optionA?.search_key ?? '').toLowerCase());
	};
	const handleOnChange = (e) => setSearchValue(e.target.value);

	const handleOnSearch = (e) => {
		const value = isMobile ? e : searchRef.current.input.value.trim();
		const searchKeys = { search: value };
		const queryString = GeneralHelper.objectToQueryString(searchKeys);

		history.push(`/?${queryString}`);
	};

	const handleOnClear = () => {
		if (onClear) onClear();
		setSearchValue(value || null);
		// searchRef.current.input.value = '';
		// setSearchValue(searchRef.current.input.value);
		// setIsTouched(false);
		history.push('/');
	};

	useEffect(() => {
		setSearchValue(value);
	}, [value]);

	useEffect(() => {
		if (options) {
			let label;
			const modified_options = options.map(option => {
				if (option?.name && option?.building_name) {
					label = `${option.name}, ${option.building_name}`;
				} else if (option?.full_name) {
					label = option.full_name;
				}
				return {
					label,
					value: option._id,
					building_floor_id: option?.building_floor_id && option?.building_floor_id?._id ? option?.building_floor_id._id : undefined,
					search_key: option?.remote_id ? `${label}, ${option.remote_id}` : label
				};
			});
			setLocationsOptions(modified_options);
		}
	}, [options]);

	return (
		<>
			<div
				className={className}
				style={style}
			>
				{
				}
				<Select
					className="location-search-select"
					value={searchValue}
					ref={searchRef}
					labelInValue
					optionFilterProp="search_key"
					notFoundContent={loading ? <Spin size="small" /> : null}
					options={locationsOptions}
					size="large"
					showSearch
					name="search"
					placeholder="Search for buildings, facilities or places"
					filterSort={hadleFilterSelect}
					onSelect={(data, option) => {
						if (searchRef.current) searchRef.current.blur();
						onSelect(data, option);
					}}
					suffixIcon={
						<Button
							type="link"
							style={{ margin: 0, pointerEvents: 'all', cursor: 'pointer' }}
							onClick={hasResults || nullish ? handleOnClear : undefined}
							icon={
								loading ?
									<LoadingOutlined /> :
									hasResults || searchValue || nullish ?

										<FontAwesomeIcon
											icon={faClose}
											fontSize={14}
											fontWeight="normal"
										/>
										:
										<FontAwesomeIcon
											icon={faSearch}
											fontSize={16}
											fontWeight="normal"
										/>
							}
						/>
					}
					onSearch={handleSelectOnChange}
				/>
			</div>
		</>
	);
};

export default LocationSearch;